import { Unreachable } from '@lemon8/web-app-shared/util';
import { atom } from 'jotai';
import { $SharingPageLevelTraffic, IHashtagPageTraffic } from 'shared/atoms';
import { EPageType } from 'shared/constant';

export const $CurrentHashtagId = atom((get) => {
  const traffic = get($SharingPageLevelTraffic);
  const { pageType } = traffic;

  if (pageType !== EPageType.HASHTAG) {
    Unreachable(`invalid page type: ${pageType}`);
  }

  const userTraffic = traffic as IHashtagPageTraffic;

  return userTraffic.hashtagId;
});
